import { makeStyles, type Theme } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
      background: COLORS.gray.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
    },
    rootImage: {
      '&:hover $imageActions': {
        pointerEvents: 'auto',
        opacity: '1',
      },

      // in case we are limited in space, we want to keep the actions always
      // positioned at the top-right corner of the "select image area"
      '&$staticActionsPosition': {
        position: 'relative',
        '& $imageFrame': {
          position: 'static',
        },
        '& $imageActions': {
          inset: `${theme.spacing(1)}px ${theme.spacing(1)}px auto auto`,
        },
      },

      '&$verticalActions': {
        '& $imageActions': {
          flexFlow: 'column nowrap',
        },
      },
    },
    staticActionsPosition: {},
    verticalActions: {},

    button: {},
    imageButton: {
      display: 'contents',
    },
    imageFrame: {
      position: 'relative',
      maxHeight: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: COLORS.gray.white,
      borderRadius: theme.shape.borderRadius,
    },
    image: {
      maxHeight: '100%',
      maxWidth: '100%',
    },
    imageActions: {
      position: 'absolute',
      inset: `0 auto auto calc(100% + ${theme.spacing(1)}px)`,
      display: 'flex',
      flexFlow: 'row nowrap',
      gap: theme.spacing(1),

      pointerEvents: 'none',
      opacity: '0',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
      }),
    },
  }),
  { name: 'SelectImageArea' }
);
